import styled from 'styled-components/macro'
import ButtonToStyle from 'ui/Button'

export const Button = styled(ButtonToStyle)`
  margin-top: 2.4rem;
`
